import { render, staticRenderFns } from "./SalePricesManagement.vue?vue&type=template&id=0414ab1e"
import script from "./SalePricesManagement.vue?vue&type=script&lang=js"
export * from "./SalePricesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports